import { render, staticRenderFns } from "./FormEditCliente.vue?vue&type=template&id=5b7d6581&"
import script from "./FormEditCliente.vue?vue&type=script&lang=js&"
export * from "./FormEditCliente.vue?vue&type=script&lang=js&"
import style0 from "./FormEditCliente.vue?vue&type=style&index=0&id=5b7d6581&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports